import { useServiceCatalogId } from 'domain/organization/serviceCatalog/useServiceCatalogId';
import { useAuthorization } from 'framework/authorization';
import { KPI_STRUCTURE_READ, KPI_VALUES_READ_LIST } from '../kpi/useKPIService';
import { SidebarStickyMenu, SummaryMenuItem, SidebarMenuItem } from 'framework/ui/menu';
import { useServiceCatalogUrl } from 'domain/shared/serviceCatalog';

const ViewServiceCatalogPageMenu = () => {
  const id = useServiceCatalogId();
  const { isGranted } = useAuthorization();

  const { getSingleEntityUrl, getCostsStructuresUrl, getKPIStructuresUrl, getKPIValuesUrl } = useServiceCatalogUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem exact linkUrl={getSingleEntityUrl(id)} />
      <SidebarMenuItem exact icon="list" linkUrl={getCostsStructuresUrl(id)} name="Costs structure" />
      {isGranted(KPI_STRUCTURE_READ) ? (
        <SidebarMenuItem exact icon="check" linkUrl={getKPIStructuresUrl(id)} name="KPI structure" />
      ) : (
        <></>
      )}
      {isGranted(KPI_VALUES_READ_LIST) ? (
        <SidebarMenuItem exact icon="tasks" linkUrl={getKPIValuesUrl(id)} name="KPI values" />
      ) : (
        <></>
      )}
    </SidebarStickyMenu>
  );
};

export default ViewServiceCatalogPageMenu;
